import React, { useEffect, useState } from 'react';
import api_powerapps from '../../../services/powerapps/index'
import qs from 'qs';
import oikosApi from '../../../services/oikos'

import { Button, Card, CardBody, Col, Media, Row, Spinner } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import FinCard from '../../../utils/card/FinCard';
import moment from 'moment';
import FinResultCard from '../../../utils/card/FinResultCard';
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import PieChart from '../../../utils/chart/PieChart';
import PqGridView from '../../Modal/PqGridView';
import BlurOverlay from '../../TestPhaseComponent/BlurOverlay';
import { notifyDefault, notifySuccess, notifyWarning } from '../../../utils/notify';


const ProjectFinancialResume = ( props ) => {

  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);
  const [dataDashboard, setDataDashboard] = useState([]);
  const [products, setProducts] = useState([]);
  const [ time, setTime ] = useState(moment());
  const [ mediaAprov, setMediaAprov] = useState(0);
  const [ mes, setMes ] = useState([]);
  const [ pqGridViewIsOpen, setPqGridViewIsOpen ] = useState(false)
  let interval =
  useEffect(()=>{
    interval = setInterval(() => setTime(moment()), 1000)
    if (props.orcRubr_id) {
      getDataFinanceiro();
    }
  }, [])

  const atualizaGraficoMes = (mes) => {
    setMes(mes + 1);
  }

  const handleChange = (e) => {
    atualizaGraficoMes(e)
    console.log(`Você selecionou o mês ${e}!`)
    //this.setState({extratoModalIsOpen: true})
  }

  const getDataFinanceiro = async () => {
    const formDataResultadoMensal = {
      'acao': 'resultado_mensal_projeto',
      'nivel3_id': props.orcRubr_id,
    }
    const res = await api_powerapps.post('/', formDataResultadoMensal, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })
    if (!res.data) {
      setDataDashboard(null);
      setIsLoading(false);
      return;
    };
    const sortedValues = Object.values(res.data).sort((a, b) => {
      // Split "mes" into [year, month] for proper comparison
      const [monthA, yearA] = a.mes.split('/').map(Number);
      const [monthB, yearB] = b.mes.split('/').map(Number);
      return yearA === yearB ? monthA - monthB : yearA - yearB;
    });

    const serieAcumulado = sortedValues.map(item => item.acumulado);
    const serieReceita = sortedValues.map(item => item.receita);
    const serieDespesa = sortedValues.map(item => item.despesa);
    const serieResultado = sortedValues.map(item => item.resultado);
    const serieLabel = sortedValues.map(item => item.mes);

    const options = {
      labels: serieLabel,
      chart: {
        type: 'bar',
        toolbar: {
          show: false,
        },
        events: {
          dataPointSelection: function(event, chartContext, config) {
            //console.log(config['dataPointIndex'])
            handleChange(config['dataPointIndex'])
          }
        },
      },
      stroke: {
        width: [0, 0, 0, 4],
        curve: 'smooth',
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      colors: ['#5664d2', '#1cbb8c', '#ffff00', '#3fa3ff'],
      yaxis: [{
        seriesName: 'Receita',
        labels: {
          formatter: (value) => {
            return value.toFixed(0)
          },
        },
        show: true,
        title: {
          text: 'Receita',
        },
      }, {
        seriesName: 'Receita',
        show: false,
        labels: {
          formatter: (value) => {
            return value.toFixed(0)
          },
        },
        title: {
          text: 'Despesa',
        },
      }, {
        show: false,
        labels: {
          formatter: (value) => {
            return value.toFixed(0)
          },
        },
        seriesName: 'Receita',
        title: {
          text: 'Resultado',
        },
      }, {
        opposite: true,
        labels: {
          formatter: (value) => {
            return value.toFixed(0)
          },
        },
        title: {
          text: 'Acumulado',
        },
      }],
    };

    const series = [{
      name: 'Receita',
      type: 'column',
      data: serieReceita,
    }, {
      name: 'Despesa',
      type: 'column',
      data: serieDespesa,
    }, {
      name: 'Resultado',
      type: 'column',
      data: serieResultado,
    }, {
      name: 'Acumulado',
      type: 'line',
      data: serieAcumulado,
    }];

    setOptions(options);
    setSeries(series);

    /*
    VERIFICAÇÃO DE DOTAÇÕES
    */

    const orcDots = [];
    const orcRubrFilhas = await oikosApi.get(`/${qs.stringify({
      action: 'get',
      table: 'orcRubr',
      data: {
        orcRubr_mae: props.orcRubr_id,
      }
    })}`)

    if (orcRubrFilhas.data && orcRubrFilhas.data.length > 0) {
      for (const orcRubrFilha of orcRubrFilhas.data) {
        const orcDot = await oikosApi.get(`/${qs.stringify({
          action: 'get',
          table: 'orcDot',
          data: {
            orcRubr_id: orcRubrFilha.orcRubr_id,
          }
        })}`)

        if (orcDot.data && orcDot.data.length > 0) {
          orcDots.push(...orcDot.data);
        }
      }
    }

    if (orcDots.length === 0) {
      const formDataDashboardFinanceiro = {
        'acao': 'dashboard_financeiro_projeto',
        'nivel3_id': props.orcRubr_id,
      }
      console.log(props.orcRubr_id)
      try {
        // início da requisição
        const res = await api_powerapps.post('/', formDataDashboardFinanceiro, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        }) // requisição propriamente dita
        console.log('res', res) // debug
        if (!res.data) {
          setDataDashboard(null);
          setIsLoading(false);
          return
        };
        console.log('data', Object.values(res.data)) // debug
        const { data } = res // extração de dados da requisição
        console.log('data:', data) // debug
        setDataDashboard(data[0]) // salva dados que vieram da requisição para dentro da variável de estado
      } catch (err) {
        console.log('Não foi possível carregar a série de dados a partir do MySQL.', err)
      }
    }

    getProdutosData()

    setIsLoading(false);
  }

  const getProdutosData = async () => {

    const queryString = qs.stringify({
        action: 'get',
        table: 'prod',
        data: {
          proj_id: props.project.proj_id,
        },
        fields: {
          '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusActual_id',
          '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)': 'prodStatusPenultimo_id',
          '(SELECT psa.prodStatusAlt_dtCria FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND prodStatusTp_id = 7 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'status7_data',
          '(SELECT psa.prodStatusAlt_dtCria FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND prodStatusTp_id = 6 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'status6_data',
          '(SELECT psa.prodStatusAlt_dtCria FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND prodStatusTp_id = 5 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'status5_data',
        }
    });
    const res = await oikosApi.get(`/?${queryString}`);

    setProducts(res.data);

    let soma = 0;
    let count = 0;

    for (const product of res.data) {
      if(product.status6_data && product.status7_data) {
        count = 1;
        soma = (new Date(product.status7_data).getTime() - new Date(product.status6_data).getTime());
      }
      count += 1;
    };

    setMediaAprov((((soma/count)/1000)/60)/60);

  }

  const runImportarOrcamento = async (projId) => {
    setIsLoading(true);
    try {
      const req = await api_powerapps.post('/', {acao: 'importar_orcamento', proj_id: projId}, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })

      notifyWarning(req.data);

      if (props.orcRubr_id) {
        getDataFinanceiro();
      }
    } catch (err) {
      notifyWarning('Erro ao buscar dados do orçamento.');
    }
    setIsLoading(false);

  }

  if(isLoading) {
    return (
      <>
        <PqGridView
          isOpen={
            pqGridViewIsOpen
          }
          Path={`https://oikos.ecoss.is/oikos/planilha.orcamento2026.single.php?proj_id=${props.project.proj_id}&login123=${props.userOikos.pf_emailProf}&pass123=${props.userOikos.pf_senha}`}
          Header={`Planilha Orçamentária`}
          toggle={() => {
            setPqGridViewIsOpen(false)
          }}
        />
        <Button
          size="sm"
          color="link"
          className="mb-1 px-0"
          onClick={() => { setPqGridViewIsOpen(true) }}
        >
          Planilha Orçamentária
        </Button>
        <div className="centered">
          <Spinner/>
        </div>
      </>
    )
  }

  else if(!isLoading && dataDashboard === null) {
    return (
      <>
        <PqGridView
          isOpen={
            pqGridViewIsOpen
          }
          Path={`https://oikos.ecoss.is/oikos/planilha.orcamento2026.single.php?proj_id=${props.project.proj_id}&login123=${props.userOikos.pf_emailProf}&pass123=${props.userOikos.pf_senha}`}
          Header={`Planilha Orçamentária`}
          toggle={() => {
            setPqGridViewIsOpen(false)
          }}
        />
        <Button
          size="sm"
          color="link"
          className="mb-1 px-0"
          onClick={() => { setPqGridViewIsOpen(true) }}
        >
          Planilha Orçamentária
        </Button>
        <div className="centered">
          Despesas em cadastramento.<br />
          <Button onClick={() => runImportarOrcamento(props.project.proj_id)}>Importar orçamento do comercial</Button>
        </div>
      </>
    )
  }

  let ptBR = Intl.NumberFormat("pt-BR", {
    style: "decimal",
    currency: "BRL",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })

  return (
    <>
        <PqGridView
          isOpen={
            pqGridViewIsOpen
          }
          Path={`https://oikos.ecoss.is/oikos/planilha.orcamento2026.single.php?proj_id=${props.project.proj_id}&login123=${props.userOikos.pf_emailProf}&pass123=${props.userOikos.pf_senha}`}
          Header={`Planilha Orçamentária`}
          toggle={() => {
            setPqGridViewIsOpen(false)
          }} />
      <div className="d-flex justify-content-between">
        <Button
          size="sm"
          color="link"
          className="mb-1 px-0"
          onClick={() => { setPqGridViewIsOpen(true) }}
        >
          Planilha Orçamentária
        </Button>
        <Breadcrumbs
          breadcrumbItems={[{
            title: (moment(time).format('dddd, DD [de] MMMM [de] YYYY, HH:mm')).toLowerCase(),
          }]}
        />
      </div>
      <BlurOverlay enabled={props.userOikos.perm_id > 3}>
        <Row>
          <Col xl={4}>
            <FinCard title={`Resultado Acumulado - ${(moment(time).format('YYYY')).toLowerCase()}`} value={dataDashboard.resultado_real} planned_var={dataDashboard.resultado_planned_var} interpretation={1} />
          </Col>
          <Col xl={4}>
            <FinCard title={`Receita Acumulada - ${(moment(time).format('YYYY')).toLowerCase()}`} value={dataDashboard.receita_real} planned_var={dataDashboard.receita_planned_var} interpretation={1} />
          </Col>
          <Col xl={4}>
            <FinCard title={`Despesa Acumulada - ${(moment(time).format('YYYY')).toLowerCase()}`} value={dataDashboard.despesa_real} planned_var={dataDashboard.despesa_planned_var} interpretation={-1} />
          </Col>
        </Row>
        <Row>
          <Col xl={5}>
            <FinResultCard
              title={`Orçado - ${(moment(time).format('YYYY')).toLowerCase()}`}
              revenue_title="Receita"
              revenue_value={dataDashboard.receita_orcada}
              expense_title="Despesa"
              expense_value={dataDashboard.despesa_orcada}
              result_title="Resultado"
              result_value={dataDashboard.resultado_orcado}
              margin={dataDashboard.margem_orcada}
              roi={dataDashboard.retorno_orcado}
            />
          </Col>
          <Col xl={5}>
            <FinResultCard
              title={`Projetado Atualizado - ${(moment(time).format('YYYY')).toLowerCase()}`}
              revenue_title="Receita"
              revenue_value={dataDashboard.receita_atualizada}
              expense_title="Despesa"
              expense_value={dataDashboard.despesa_atualizada}
              result_title="Resultado"
              result_value={dataDashboard.resultado_atualizado}
              margin={dataDashboard.margem_atualizada}
              roi={dataDashboard.retorno_atualizado}
            />
          </Col>
          <Col xl={2}>

            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <h4 className="card-title mb-4">Break-even - {(moment(time).format('YYYY')).toLowerCase()}</h4>
                  </Col>
                </Row>

                <Media>
                  <Media body className="overflow-hidden">
                    <p className="text-truncate font-size-14 mb-2">Margem de projetos</p>
                    <h4 className="mb-0">{ptBR.format(100*dataDashboard.margemcontribuicao_futura)}%</h4>
                  </Media>
                </Media>
                <Media>
                  <Media body className="overflow-hidden">
                    <p className="text-truncate font-size-14 mb-2">Incremento</p>
                    <h4 className="mb-0">{ptBR.format(dataDashboard.necessidade_receita)}</h4>
                  </Media>
                </Media>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <h4 className="card-title mb-4">
                  Resultado mensal
                </h4>
                <div>
                  <div id="line-column-chart" className="apex-charts" dir="ltr">
                    <ReactApexChart
                      options={options}
                      series={series}
                      height="280"
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <PieChart
              title="Composição das receitas (por evento de pagamento)"
              req="detalhamento_projeto"
              pars={(mes && `nivel3_id=${props.orcRubr_id}&Fluxo=Entrada`)}
              groupby="mov_desc"
              src="powerapps"
            />
          </Col>
          <Col xl={6}>
            <PieChart
              title="Composição das receitas (por risco)"
              req="detalhamento_projeto"
              pars={mes && `nivel3_id=${props.orcRubr_id}&Fluxo=Entrada`}
              groupby="mov_risco"
              src="powerapps"
            />
          </Col>
        </Row>
        <Row>
          <Col xl={6}>
            <PieChart
              title="Composição das despesas (por categoria)"
              req="detalhamento_projeto"
              pars={mes && `nivel3_id=${props.orcRubr_id}&Fluxo=Saida`}
              groupby="nivel4"
              src="powerapps"
            />
          </Col>
          <Col xl={6}>
          <Card>
            <CardBody>
              <h4 className="card-title mb-4">Tempo médio de aprovação dos produtos:</h4>
              <h4>{mediaAprov.toFixed(2)} horas</h4>
            </CardBody>
          </Card>
          </Col>
        </Row>
      </BlurOverlay>
    </>
  );
};

export default ProjectFinancialResume;
